import React, { useState } from "react";
import {
    Link,
    List,
    ListItemText,
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton
} from "@mui/material/";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles";
import { strings } from "../../i18n";

const ShowMore = ({ data, title }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const uniqData = [...new Set(data)];

    const openModal = (event) => {
        event.stopPropagation();
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    return (
        <>
            <Box className="main-component">
                {uniqData.length > 1 ? (
                    <>
                        <Typography
                            variant="caption"
                            component="div"
                            texttransform={"capitalize"}
                        >
                            {uniqData[0]}
                        </Typography>
                        <Link
                            component="button"
                            variant="caption"
                            onClick={openModal}
                        >
                            {`+ ${uniqData.length - 1} ${strings("more")}`}
                        </Link>
                    </>
                ) : (
                    <Typography variant="caption" texttransform={"capitalize"}>
                        {uniqData[0]}
                    </Typography>
                )}
            </Box>
            <Dialog
                open={modalIsOpen}
                fullWidth
                maxWidth={"xs"}
                onClose={closeModal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {strings(title)}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={closeModal}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <List dense={false}>
                        {uniqData.map((item, index) => (
                            <ListItemText
                                texttransform="capitalize"
                                sx={styles.listText}
                                key={index}
                                primary={item}
                            />
                        ))}
                    </List>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ShowMore;
